<div class="branding-colors-container attribute-list-container">
  <div class="branding-colors__row">
    <div class="branding-colors__copy">
      <label class="control-label" for="branding-base-color">Dark color</label>
      <p>Pick a dark color.</p>
    </div>
    <color-picker
      tabindex="0"
      pickerId="branding-base-color"
      [ngModel]="brandingSettings.baseColor"
      (ngModelChange)="saveBrandColor('baseColor', $event)"
      ngDefaultControl
    ></color-picker>
  </div>

  <div class="branding-colors__row">
    <div class="branding-colors__copy">
      <label class="control-label" for="branding-accent-color"
        >Light color</label
      >
      <p>Pick a light color.</p>
    </div>
    <color-picker
      tabindex="0"
      pickerId="branding-accent-color"
      [ngModel]="brandingSettings.accentColor"
      (ngModelChange)="saveBrandColor('accentColor', $event)"
      ngDefaultControl
    ></color-picker>
  </div>
</div>
